import { Route, Routes } from "react-router-dom";

import LayoutOutlet from "../layouts/layoutOutlet";

import LandingPage from "../pages/landingPage";
import AboutUsPage from "../pages/aboutUsPage";
import ContactUsPage from "../pages/contactUsPage";
import GamePlayPage from "../pages/gamePlayPage";

import PrivacyPolicyPage from "../pages/privacyPolicyPage";
import TermsNConditionsPage from "../pages/termsNConditionsPage";

import NotFoundPage from "../pages/notFoundPage";

const Router = () => {
    return(
        <Routes>
            <Route path="/" element={<LayoutOutlet />}>
                <Route index element={<LandingPage />} />

                <Route path="about-us" element={<AboutUsPage />} />
                <Route path="contact-us" element={<ContactUsPage />} />
                <Route path="play" element={<GamePlayPage />} />

                <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="terms-and-conditions" element={<TermsNConditionsPage />} />

                <Route path="*" element={<NotFoundPage />} />
            </Route>
        </Routes>
    );
}

export default Router;